export default __webpack_public_path__ + "static/media/linkedin-grey.356e1362.svg";